import { ChartTypeEnum, chartTypeDataType } from '../model/chart_type.enum';

const CANDLE_PERPETUAL = 'CANDLE_PERPETUAL';
const CANDLE_GET_DATA = chartTypeDataType(ChartTypeEnum.CandleStick);
const CANDLE_UPDATE_DATA = chartTypeDataType(ChartTypeEnum.CandleStick) + '_update';
const CANDLE_UPDATE_CLOSEST_DATA = chartTypeDataType(ChartTypeEnum.CandleStick) + '_closest';
const CANDLE_CALENDAR_DATA = chartTypeDataType(ChartTypeEnum.CandleStick) + '_calendar';
const CMVOL_FULL_DATA_UPDATE = 'CMVOL_FULL_DATA_UPDATE';
const CMVOL_DATA_UPDATE = 'CMVOL_DATA_UPDATE';
const CMVOL_DATA_UPDATE_CLOSEST_FORWARD = 'CMVOL_DATA_UPDATE_CLOSEST_FORWARD';

const CM_SERIES_GET_DATA = chartTypeDataType(ChartTypeEnum.Line);
const CM_SERIES_UPDATE_DATA = chartTypeDataType(ChartTypeEnum.Line) + '_update';
const CANDLE_SUBSCRIPTION = 'CANDLE_SUBSCRIPTION';

const ALL_DATA = 'ALL_DATA';

export const CHART_EVENTS_KEYS = {
  CANDLE_PERPETUAL: 'CANDLE_PERPETUAL',
  CANDLE_GET_DATA: chartTypeDataType(ChartTypeEnum.CandleStick),
  CANDLE_UPDATE_DATA: chartTypeDataType(ChartTypeEnum.CandleStick) + '_update',
  CANDLE_UPDATE_CLOSEST_DATA: chartTypeDataType(ChartTypeEnum.CandleStick) + '_closest',
  CANDLE_CALENDAR_DATA: chartTypeDataType(ChartTypeEnum.CandleStick) + '_calendar',
  CMVOL_FULL_DATA_UPDATE: 'CMVOL_FULL_DATA_UPDATE',
  CMVOL_DATA_UPDATE: 'CMVOL_DATA_UPDATE',
  CMVOL_DATA_UPDATE_CLOSEST_FORWARD: 'CMVOL_DATA_UPDATE_CLOSEST_FORWARD',
  CM_SERIES_GET_DATA: chartTypeDataType(ChartTypeEnum.Line),
  CM_SERIES_UPDATE_DATA: chartTypeDataType(ChartTypeEnum.Line) + '_update',
  CANDLE_SUBSCRIPTION: 'CANDLE_SUBSCRIPTION',
};

export const CHART_EVENTS = [
  CANDLE_PERPETUAL,
  CMVOL_FULL_DATA_UPDATE,
  CMVOL_DATA_UPDATE,
  CANDLE_GET_DATA,
  CANDLE_CALENDAR_DATA,
  CANDLE_UPDATE_DATA,
  CANDLE_UPDATE_CLOSEST_DATA,
  CMVOL_DATA_UPDATE_CLOSEST_FORWARD,
  CM_SERIES_GET_DATA,
  CM_SERIES_UPDATE_DATA,
  CANDLE_SUBSCRIPTION,
  ALL_DATA,
];

export const GALLERY_EVENTS = ['GET_VOL_CMVOLSURFACE', 'GET_VOL_VOLSURFACE'];

export const SUPPORTED_CURRENCIES = ['BTC', 'ETH', 'SOL', 'XRP', 'BNB'];

export const VOL_SURFACES = [
  '5C',
  '5FLY',
  '5P',
  '5RR',
  '10C',
  '10FLY',
  '10P',
  '10RR',
  '15C',
  '15FLY',
  '15P',
  '15RR',
  '20C',
  '20FLY',
  '20P',
  '20RR',
  '25C',
  '25FLY',
  '25P',
  '25RR',
  '30C',
  '30FLY',
  '30P',
  '30RR',
  '35C',
  '35FLY',
  '35P',
  '35RR',
  '40C',
  '40FLY',
  '40P',
  '40RR',
  'ATMF',
  'FUTURE',
  'T',
];

export const TENORS = ['1D', '2D', '3D', '1W', '2W', '1M', '2M', '3M', '6M', '9M', '1Y'];

export const SUBSCRIPTIONS_KEY = {
  CANDLE_SUBSCRIPTION: 'CANDLE_SUBSCRIPTION',
  CMVOL_SUBSCRIPTION: 'CMVOL_SUBSCRIPTION',
  TOKEN_DATA: 'TOKEN_DATA',
  SNAPSHOT_DATA: 'snapshot_data',
  VOL_SMILE_UPDATE_DATA: 'VOL_SMILE_UPDATE_DATA',
  GET_VOL_CMVOLSURFACE: 'GET_VOL_CMVOLSURFACE',
  GET_VOL_VOLSURFACE: 'GET_VOL_VOLSURFACE',
  FUNDING_TICKETS: 'FUNDING_TICKETS',
  TIMESERIES_SUBSCRIPTION: 'TIMESERIES_SUBSCRIPTION',
  TIMESERIES_SUBSCRIPTION_CANDLE: 'TIMESERIES_SUBSCRIPTION_CANDLE',
  TOKEN_VOLATILITY_TIMESERIES_SUBSCRIPTION: 'TOKEN_VOLATILITY_TIMESERIES_SUBSCRIPTION',
  TOKEN_VOLATILITY_TIMESERIES_SUBSCRIPTION_CANDLE:
    'TOKEN_VOLATILITY_TIMESERIES_SUBSCRIPTION_CANDLE',
  TK_DATA_WIDGET_SUBSCRIPTION: 'TK_DATA_WIDGET_SUBSCRIPTION',
  PP_TICKER: 'PP_TICKER',
  MARKET_PROBABILITIES: 'MARKET_PROBABILITIES',
};
